import React, { useEffect, useState } from 'react';

import {
    Container as MaterialContainer,
    UiDialog as Dialog,
    Grid,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';

import { HeaderContainer, TitleIcon } from 'common/components';

import * as actions from './actions';
import { ListItems, ProductForm } from './components';
import * as selectors from './selectors';

const SystemsContainer = ({
    fetchSystems,
    handleClickCloseModalProduct,
    handleClickUpdate,
    isFetching,
    isNewRecord,
    isOpenModal,
    systems,
}) => {
    const { t } = useTranslation();
    const [filterData, setFilterData] = useState({
        searchText: '',
    });

    useEffect(() => {
        fetchSystems(filterData);
    }, []);

    return (
        <MaterialContainer maxWidth={false}>
            <HeaderContainer>
                <Grid size="grow">
                    <TitleIcon title={t('System', { count: 2 })} />
                </Grid>
            </HeaderContainer>
            <ListItems
                filterData={filterData}
                filterItems={fetchSystems}
                handleClickUpdate={handleClickUpdate}
                isFetching={isFetching}
                items={systems}
                setFilterData={setFilterData}
            />

            <Dialog
                onClose={() => handleClickCloseModalProduct()}
                open={isOpenModal}
                size="md"
                title={isNewRecord ? t('Create preset') : t('Update preset')}
            >
                <ProductForm
                    handleClickCloseForm={handleClickCloseModalProduct}
                />
            </Dialog>
        </MaterialContainer>
    );
};

const mapStateToProps = createStructuredSelector({
    isFetching: selectors.getIsFetchingSystems,
    isNewRecord: selectors.getIsNewRecord,
    isOpenModal: selectors.getIsOpenModal,
    systems: selectors.getFetchSystemsData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchSystems: (filterData) => dispatch(actions.fetchSystems(filterData)),
    handleClickCloseModalProduct: () => dispatch(actions.closeModal()),
    handleClickUpdate: (id) => dispatch(actions.fetchItem(id)),
});

SystemsContainer.propTypes = {
    fetchSystems: PropTypes.func,
    handleClickCloseModalProduct: PropTypes.func,
    handleClickUpdate: PropTypes.func,
    isFetching: PropTypes.bool,
    isNewRecord: PropTypes.bool,
    isOpenModal: PropTypes.bool,
    systems: PropTypes.array,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
    SystemsContainer,
);
